import axios from "axios";
import { takeLatest, put } from "redux-saga/effects";

import { API_BASE_URI } from "../ApiCall";
import { DocumentActionTypes } from "./Document.type";
import { formatQuery } from "../Utils";

export function* fetchAllDocuments(action?: any): any {
  try {

    const response = yield axios.get(`${API_BASE_URI}/document?${formatQuery(action)}`);

    yield put({
      type: DocumentActionTypes.FETCH_ALL_DOCUMENT_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: DocumentActionTypes.FETCH_ALL_DOCUMENT_FAILURE,
      payload: error,
    });
  }
}

export function* fetchOneDocument(action: any): any {
  try {
    const response = yield axios.get(`${API_BASE_URI}/document/${action.payload}`);
    yield put({
      type: DocumentActionTypes.FETCH_ONE_DOCUMENT_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: DocumentActionTypes.FETCH_ONE_DOCUMENT_FAILURE,
      payload: error,
    });
  }
}

export function* watcherFetchAllDocuments() {
  yield takeLatest(DocumentActionTypes.FETCH_ALL_DOCUMENT, fetchAllDocuments);
}

export function* watcherFetchOneDocument() {
  yield takeLatest(DocumentActionTypes.FETCH_ONE_DOCUMENT, fetchOneDocument);
}
